import React, { useState, useEffect } from 'react';
import "./SideBar.css"
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import PreviewIcon from '@mui/icons-material/Preview';
import ConstructionIcon from '@mui/icons-material/Construction';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BiotechIcon from '@mui/icons-material/Biotech';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import SafetyDividerIcon from '@mui/icons-material/SafetyDivider';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
const Sidebar = () => {
  const [activeItem, setActiveItem] = useState(null);

  const handleItemClick = (index) => {
    setActiveItem(index);

    // Scroll to the corresponding div
    const targetDiv = document.getElementById(`section-${index}`);
    if (targetDiv) {
      targetDiv.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Define your sidebar items with names and default icons
  const sidebarItems = [
    { name: 'الرجوع للأعلى', icon: <VerticalAlignTopIcon/> },
    { name: 'نظرة عامة', icon: <PreviewIcon/> },
    { name: 'سيو', icon: <ConstructionIcon/> },
    { name: 'قابلية الاستخدام', icon:<ManageAccountsIcon/>},
    { name: 'جوال', icon: <PhoneIphoneIcon/> },
    { name: 'التكنولوجيا', icon:<BiotechIcon/> },
    { name: 'اجتماعي', icon: <SafetyDividerIcon/> },
    { name: 'زوار', icon: <SupervisorAccountIcon/> },
    { name: 'تحليل الارتباط', icon: <SignalCellularAltIcon/> },
  ];

  // Set the default item index (نظرة عامة in this case)
  const defaultItemIndex = 0;

  useEffect(() => {
    // Simulate a click on the default item when the component mounts
    handleItemClick(defaultItemIndex);
  }, []); // Empty dependency array ensures this effect runs once on mount


  return (
    <div className="sidebar">
      <ul className="UlSidebar">
        {sidebarItems.map((item, index) => (
          <li
            key={index}
            className={index === activeItem ? 'active' : 'LISidebar'}
            onClick={() => handleItemClick(index)}
          >
            <span className="name">{item.name}</span>
            <span className="icon">{item.icon}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
